module.exports = __webpack_public_path__ + "img/CSL.92dec38b.png";